import { t } from "../../../hooks/useAppTranslation";
import {useState} from 'react';
import {getDroppedOrSelectedFiles} from 'html5-file-selector';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';

import * as fileService from '../../HttpService/FileManager';


const allowedTypes = 'image/*, audio/*, video/*, .txt, .rtf, .doc, .docx, ' +
    '.xls, .xlsx, .ppt, .pptx, .pps, .zip, .rar, .7z, .pdf';

export const bannedExtenstions = ['.ade', '.adp', '.bat', '.chm', '.cmd', '.com', '.cpl',
   '.exe', '.dll', '.hta', '.ins', '.isp', '.jar', '.jse', '.lib', '.lnk', '.mde', 
   '.msc', '.msp', '.mst', '.pif', '.scr', '.sct', '.shb', '.sys', '.vb', '.vbe', 
   '.vbs', '.vxd', '.wsc', '.wsf', '.wsh'];


export const UploadFiles = ({
  errorCallback,
  setPopUpDisabled,
  successCallback
}) => {
  /*
    This component is for uploading file to server and get key for further
    activities (mostly adding document)
  */
  const [savingOn, setSavingOn] = useState(false);

  const uploadFiles = (files) => {
    if (!files.length) { return }
    if (files[0].size > 52428800) {
      errorCallback(413);
      return
    }
    let fileList = [];
    for (let fileData of files) {
      const fileExtension = fileData.name.split('.').pop().toLowerCase();
      if (bannedExtenstions.includes('.' + fileExtension)) {
        errorCallback(415);
        return;
      }

      fileList.push({file: fileData});
    }

    setSavingOn(true);
    setPopUpDisabled(true);

    sendFiles(
      fileList,
      (fileList) => {
          setSavingOn(false);
          setPopUpDisabled(false);
          successCallback(fileList);
      },
        (error, response) => {
            setSavingOn(false);
            setPopUpDisabled(false);
            errorCallback(error, response);
        }
    );
  };

    const getFilesFromEvent = (ev) => {
      return new Promise(resolve => {
          getDroppedOrSelectedFiles(ev).then(chosenFiles => {
              uploadFiles(chosenFiles.map(f => f.fileObject));
          })
      })
    };

  return (
    <Dropzone
      disabled={savingOn}
      getFilesFromEvent={getFilesFromEvent}
      styles={{dropzone: {border: '2px dashed #0d47a1'}}}
      InputComponent={props =>
        <>
          <input
            className="dzu-input documents__upload-input"
            id="filesInput"
            multiple
            type="file"
            onChange={getFilesFromEvent}
          />
          <label className="dzu-inputLabel documents__upload-label" htmlFor="filesInput">
            {savingOn ? t('g-saving-files') : t('g-78')}
          </label>
        </>
      }
    />
  )
};


function sendFiles(files, successCallback, errorCallback)
{
  let response_ = null;
  fileService.sendFiles(files)
      .then(response => {
        response_ = response;
        return response.json()
      })
      .then(fileList => successCallback(fileList))
      .catch(error => {
        // Attention! In some cases (e.g. 502), response is null and there is
        // no statusCode
        if (errorCallback) { errorCallback(error, response_) }
      });
}
